// DS: I3.27
import React from 'react';
import IconWrap from '../IconWrap';
const Burger = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4h20v3H2V4zm0 14h20v3H2v-3zm20-7H2v3h20v-3z",
        clipRule: "evenodd"
    })));
Burger.displayName = 'Burger';
export default Burger;

//# sourceMappingURL=Burger.js.map